import React, { useContext, useEffect } from "react";
import "./SimplePages.css";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import { Link } from "react-router-dom";

export const Cookies = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);

  useEffect(() => {
    setTitle("Cookie Policy");
    setLoading(false);
  }, []);

  return (
    <div className="simple-content ">
      <div className="simple-content-description text-start">
        <p className="c8">
          <span className="c4">
            Coca-Cola European Partners Great Britain Limited (
          </span>
          <span className="c6">we/us</span>
          <span className="c2">
            ) is committed to ensuring that your privacy is protected.
          </span>
        </p>
        <p className="c8">
          <span className="c4">
            We aim to be as open and transparent as possible around the
            information we collect when you visit our websites including through
            the use of cookies.
          </span>
        </p>
        <p className="c8">
          <span className="c2">
            This policy explains what cookies are and how we use them. It also
            explains the different types of cookies we use, and how you can
            change or delete them.
          </span>
        </p>
        <p className="c8">
          <span className="c2">
            We hope that this policy helps you understand, and feel more
            confident about, our use of cookies. If you have any further
            queries, please contact us:
          </span>
        </p>
        <ul className="c1 lst-kix_list_1-0 start">
          <li className="c9 li-bullet-0">
            <span className="c2">by calling us at 020 7812 0812; or</span>
          </li>
          <li className="c10 c21 li-bullet-0">
            <span className="c2">
              by addressing your query to Mesh Marketing Limited, 12 &ndash; 16
              Laystall Street, London, EC1R 4PF
            </span>
          </li>
        </ul>
        <p className="c8">
          <span className="c4">
            For information on how your information is collected and used by us
            generally, please see our{" "}
          </span>
          <span className="c5 c4">
            <Link className="c11 content-link no-break" to={"/privacy-policy"}>
              privacy policy
            </Link>
          </span>
          <span className="c2">.</span>
        </p>
        <ol className="c1 lst-kix_list_2-0 start" start="1">
          <li className="c9 li-bullet-0">
            <span className="c6">WHAT IS A COOKIE?</span>
            <span className="c2">
              <br />
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_2-1 start" start="1">
          <li className="c0 li-bullet-0">
            <span className="c2">
              Cookies are small text files. They are stored by your browser onto
              your computer or mobile device. They are widely used in order to
              make websites work or work in a better, more efficient way. They
              can do this because websites can read and write these files,
              enabling them to recognise you and remember important information
              that will make your use of a website more convenient (eg by
              remembering your user preferences).
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c2">
              Most web browsers automatically accept cookies, but if you do not
              want information collected this way, there is a simple procedure
              in most browsers that allows you to deny or accept the cookies
              feature (please read section 4 below for more details about how to
              do this).
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c4">
              The two types of cookies we use are known as{" "}
              <strong>session</strong> cookies and <strong>persistent</strong>{" "}
              cookies. These may be cookies which we use and/or a third party
              uses.
            </span>
            <ol className="c1 lst-kix_list_2-2 start" start="1">
              <li className="c12 c17 li-bullet-0">
                <span className="c6">
                  <strong>Session cookie</strong>
                  <br />
                </span>
                <span className="c2">
                  A session cookie is used each time you visit our website to
                  give you a session ID. We use this type of cookie to link your
                  actions on our website and each session cookie will only last
                  for a browser session, at the end of which it will expire.
                  Each browser session will start when you open your browser
                  window and finish when you close your browser window. After
                  your visit to our website all session cookies are deleted.
                  Each time you visit our website you will have a different
                  session ID.
                </span>
              </li>
              <li className="c10 c17 li-bullet-0">
                <span className="c6">
                  <strong>Persistent cookie</strong>
                  <br />
                </span>
                <span className="c2">
                  A persistent cookie allows the preferences or actions of the
                  user across a site (or across different sites) to be
                  remembered. It has a longer lifetime than a session cookie and
                  lasts for the period of time specified in the cookie (this
                  will vary from cookie to cookie). This type of cookie will not
                  be deleted when you close your browser window and will be
                  stored on your computer or mobile device. It will be activated
                  every time you visit a website which created that particular
                  persistent cookie.
                </span>
              </li>
            </ol>
          </li>
        </ol>

        <p className="c7">
          <span className="c2">
            <br />
          </span>
        </p>
        <p className="c7">
          <span className="c2"></span>
        </p>
        <p className="c7">
          <span className="c2"></span>
        </p>
        <ol className="c1 lst-kix_list_2-0" start="2">
          <li className="c9 li-bullet-0">
            <span className="c6">
              <strong>COOKIES WE USE</strong>
              <br />
            </span>
            <span className="c2">
              We only use strictly necessary cookies on our website.
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_2-1 start" start="1">
          <li className="c0 li-bullet-0">
            <span className="c6">
              <strong>Strictly necessary cookies</strong>
            </span>
            <ol className="c1 lst-kix_list_2-2 start" start="1">
              <li className="c12 c17 li-bullet-0">
                <span className="c2">
                  Why do we use strictly necessary cookies? These cookies are
                  essential to our website in order to enable you to move around
                  it and to use its features, such as remembering information
                  you have entered on forms when you move to other pages within
                  a browser session. Without strictly necessary cookies, certain
                  services which you may have asked for will not be possible and
                  our website will not perform as smoothly as we think you would
                  expect.
                </span>
              </li>
              <li className="c12 c17 li-bullet-0">
                <span className="c2">
                  How do I consent to use of strictly necessary cookies?
                  Accepting strictly necessary cookies is a condition of using
                  our website. If you reject these cookies then we cannot
                  predict how our website will perform when you visit it nor
                  guarantee your security.
                </span>
              </li>
              <li className="c10 c17 li-bullet-0">
                <span className="c2">
                  What strictly necessary cookies do we use on our website?
                </span>
              </li>
            </ol>
          </li>
        </ol>

        <a id="t.fbd5d7dc6b3e2176e5fd5b9a0250cc8ad4d2fde9"></a>
        <a id="t.0"></a>
        <div className="table-responsive">
          <table className="c14">
            <tr className="c15">
              <td className="c18" colspan="1" rowspan="1">
                <p className="c12">
                  <span className="c6">Cookie name</span>
                </p>
              </td>
              <td className="c20" colspan="1" rowspan="1">
                <p className="c12">
                  <span className="c6">Purpose</span>
                </p>
              </td>
              <td className="c18" colspan="1" rowspan="1">
                <p className="c12">
                  <span className="c6">Further information</span>
                </p>
              </td>
            </tr>
            <tr className="c15">
              <td className="c18" colspan="1" rowspan="1">
                <p className="c12">
                  <span className="c2">Session cookie</span>
                </p>
              </td>
              <td className="c20" colspan="1" rowspan="1">
                <p className="c12">
                  <span className="c2">User identification</span>
                </p>
              </td>
              <td className="c18" colspan="1" rowspan="1">
                <p className="c12">
                  <span className="c2">Finding stored user after winning </span>
                </p>
              </td>
            </tr>
          </table>
        </div>
        <p className="c12 c16">
          <span className="c6 c13">
            <br />
          </span>
        </p>
        <ol className="c1 lst-kix_list_2-0" start="3">
          <li className="c9 li-bullet-0">
            <span className="c6">
              <strong>MANAGING COOKIES</strong>
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_2-1 start" start="1">
          <li className="c0 li-bullet-0">
            <span className="c2">
              You can control which cookies you get and which you keep on your
              device. Unless you have adjusted your browser settings so that it
              will refuse our cookies, our system will issue cookies when you
              visit our website.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c2">
              Many web browsers can be set up to ask for your prior consent
              before an individual cookie is set on your device. This will give
              you control over your cookies but naturally may interfere with
              your browsing experience i.e. if you have to accept each cookie on
              our website (and on other websites you visit).
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c2">
              You may refuse to accept our cookies on your computer or mobile
              device at any time by activating the setting on your browser which
              allows you to refuse cookies. We have included links below to
              direct you to the pages of the main web browsers sites which
              provide details about changing your browser settings. For
              information on how to control cookies on web browsers which are
              not included below or on other devices which you use to view our
              website (such as on mobile phones and other mobile devices) please
              refer to your user manual.
            </span>
          </li>
          <li className="c10 c19 li-bullet-0">
            <span className="c2">
              Please note that by deleting cookies or disabling future cookies
              you may be unable to access certain areas or features of our
              website and it will mean that settings such as your stored
              username and password may have to be reset. If you adjust your
              cookie settings this will also affect the other websites you
              visit.
            </span>
          </li>
        </ol>
        <p className="c7">
          <span className="c2">
            <br />
          </span>
        </p>
        <ol className="c1 lst-kix_list_2-0" start="4">
          <li className="c9 li-bullet-0">
            <span className="c6">
              <strong>WHERE CAN I GET MORE INFORMATION ABOUT COOKIES?</strong>{" "}
            </span>
          </li>
        </ol>
        <ol className="c1 lst-kix_list_2-1 start" start="1">
          <li className="c0 li-bullet-0">
            <span className="c4">
              You can find out more information about internet advertising by
              visiting the following information websites:{" "}
            </span>
            <span className="c5 c4">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="c11 content-link"
                href="https://allaboutcookies.org/"
              >
                www.allaboutcookies.org
              </a>
            </span>
            <span className="c4">, </span>
            <span className="c4 c5">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="c11 content-link"
                href="https://www.yourchoicesonline.eu/"
              >
                www.yourchoicesonline.eu
              </a>
            </span>
            <span className="c4">, </span>
            <span className="c5 c4">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="c11 content-link"
                href="https://www.networkadvertising.org/"
              >
                www.networkadvertising.org
              </a>
            </span>
          </li>
          <li className="c10 c19 li-bullet-0">
            <span className="c2">
              Some of these sites enable you to opt out of online behavioural
              advertising and other tracking cookies (i.e. in addition to the
              control settings on your browser as set out in section 3).
            </span>
          </li>
        </ol>
        <p className="c12 c16">
          <span className="c2"></span>
        </p>
      </div>
    </div>
  );
};
